<!--
 ** @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 ** @Deion:
 ** @Date: 2022-09-16 17:13:35
 * @LastEditors: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @LastEditTime: 2022-10-21 11:39:57
 * @FilePath: /ywx-open/vue/src/views/agent/serviceDetails/orderManage/components/doctor.vue
-->
<template>
  <div>
    <div class="search-box">
      <MyForm class="search-form" :form="formData.form" :inline="true"
        :options="formData.options" />
      <div class="btns">
        <el-button type="primary" icon="el-icon-search" @click="searchForm()">搜索</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportData()">导出</el-button>
      </div>
    </div>
    <hr />
    <div>
      <MyTable :tableData="tableData" :headerColumns.sync="headerColumns" :hasPagination="true"
        :page="page" @page-change="(pagenum)=>{pageNumChange(pagenum)}"
        @size-change="(size)=>{pageSizeChange(size)}" :operation="true" :operationWidth="260">
        <template slot="status" slot-scope="scope">
          <span :style="{color:signStatusTag(scope.row.status)}">
            {{formData.form.serviceType==='2'?FirmStatusTypeEnum.getDescFromValue(scope.row.status):doctorSignStatusTypeEnum.getDescFromValue(scope.row.status)}}</span>
        </template>
        <template slot="notifyStatus" slot-scope="scope">
          <span>
            {{getNotifyStatusName(scope.row)}}</span>
        </template>
        <template slot="upDefault1" slot-scope="scope">
          <span>
            {{processTypeObj[scope.row.upDefault1]}}</span>
        </template>

        <template slot="menu" slot-scope="scope">
          <div class="flexrow">
            <el-button type="primary" size="small" @click="customerDetail(scope.row)">查看详情
            </el-button>
            <el-button
              v-if="formData.form.serviceType!=='2' && [2, 6, 7, 9].includes(scope.row.status)"
              type="warning" size="small" @click="msgRepeatSend(scope.row)">补偿通知
            </el-button>
          </div>
        </template>
      </MyTable>
    </div>
    <!-- 医师签名详情 -->
    <div>
      <el-dialog title="医师签名详情" :visible.sync="detailDialogVisible" width="65%">
        <div class="detailInfo-container">
          <h2>医师基本信息</h2>
          <el-row>
            <el-col :span="12">
              {{`标志ID：${detailInfo.uniqueid || '--'}` }}</el-col>
            <el-col v-if="grantUniqueId" :span="12"> {{`授权ID：${selfAuthsignLogId || '--'}`  }}
            </el-col>
            <el-col :span="12"> {{`医师姓名：${detailInfo.doctorName || '--'}` }}</el-col>
            <el-col :span="12"> {{`患者姓名：${detailInfo.patientName || '--'}` }}</el-col>
            <el-col :span="12"> {{`患者性别：${detailInfo.patientSex || '--'}` }}</el-col>
            <el-col :span="12"> {{`患者年龄：${detailInfo.patientAge || '--'}` }}</el-col>
            <el-col :span="12">
              {{`患者证件类型：${detailInfo.patientCardType?idCodeType[detailInfo.patientCardType]: '--'}` }}
            </el-col>
            <el-col :span="12"> {{`患者证件号：${detailInfo.patientCardNum ||  '—'}` }}
            </el-col>
          </el-row>
          <hr />
          <h2>签名原文</h2>
          <div class="flex flex1 row marginBottom20">
            <span class="marginright20">
              签名状态：
              <span
                :style="{color:signStatusTag(detailInfo.status),border:'1px solid #ccc',padding:'3px 5px'}">
                {{doctorDetailStatusType[detailInfo.status]}}</span>
            </span>
            <span v-if="detailInfo.signAlg" class="marginright20">
              签名算法：
              {{detailInfo.signAlg || '—-'}}
            </span>
            <span class="marginright20">
              签名方式：
              {{processTypeObj[detailInfo.signType] || '--'}}
            </span>
          </div>
          <div class="flex-row flex1 marginBottom20">
            <span :style="{width: '100px' }">原文JSON:</span>
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
              v-model="detailInfo.signInfo" :readonly="true">
            </el-input>
          </div>
          <!-- {/* 签名值、时间戳签名值、签章  未领取状态下不展示 */} -->
          <div v-if="detailInfo.status !== 10" class="flex-row flex1 marginBottom20">
            <span :style="{width: '100px' }">签名值:</span>
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
              v-model="detailInfo.valueSign" :readonly="true">
            </el-input>

          </div>
          <div v-if="detailInfo.status !== 10" class="flex row flex1 marginBottom20">
            <span :style="{width: '100px' }">时间戳签名值:</span>
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
              v-model="detailInfo.valueTimesign" :readonly="true">
            </el-input>
          </div>
          <div v-if="detailInfo.status !== 10" class="flex-row flex1 marginBottom20">
            <span :style="{width: '90px' }">签章:</span>
            <img v-if="detailInfo.signStampInfo" :src="addBase64(detailInfo.signStampInfo)"
              alt="签章图片" :style="{ width: '150px', height:'auto', border: '1px solid #ccc' }" />

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="detailDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 客户签名详情 -->
    <div>
      <el-dialog title="客户签名详情" :visible.sync="customerDetailDialogVisible" width="65%">
        <div>
          <el-descriptions title="" :column="2">
            <el-descriptions-item label="唯一标识">{{customerDetailInfo.uniqueid || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">{{customerDetailInfo.createTime || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="更新时间">{{customerDetailInfo.updateTime || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="签名类型">
              {{customerDetailInfo.signType || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="签名原文" :span="2" contentClassName="flex1">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
                v-model="customerDetailInfo.signInfo" :disabled="true" />
            </el-descriptions-item>
            <el-descriptions-item label="签名结果" :span="2" contentClassName="flex1">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}"
                v-model="customerDetailInfo.signResult" :disabled="true" />
            </el-descriptions-item>

          </el-descriptions>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="customerDetailDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
  <script>
import { bus } from '@/utils/bus';
import MyForm from '@/components/form/index'
import MyTable from '@/components/myTableComponent/index'
import {
  formatObj,
  serviceStatusType,
  createEnum,
  doctorSignStatusType,
  FirmStatusType,
  doctorDetailStatusType,
  processTypeObj,
  formatArrOptions,
  idCodeType,
} from '@/utils/public'
import tagColor from '@/utils/color'
import moment from 'moment'
import { addBase64, getFirmListByAgent } from '@/utils/pubilcFun'

// 服务类型
const serviceStatusTypeOptions = formatObj(serviceStatusType)
const doctorSignStatusTypeEnum = createEnum(doctorSignStatusType)
const signStatusTypeOptions = formatObj(doctorSignStatusTypeEnum.numToDescMap)
signStatusTypeOptions.unshift({ value: '', label: '全部' })
const FirmStatusTypeEnum = createEnum(FirmStatusType)
const FirmStatusTypeOptions = formatObj(FirmStatusTypeEnum.numToDescMap)
FirmStatusTypeOptions.unshift({ value: '', label: '全部' })

// 医生签名表头
const doctorSignatureHeaderColumns = [
  {
    title: '唯一标识名',
    dataIndex: 'uniqueid',
  },
  {
    title: '医师姓名',
    dataIndex: 'doctorName',
  },
  {
    title: '客户名称',
    dataIndex: 'clientIdName',
  },
  {
    title: '签名状态',
    dataIndex: 'status',
    slot: true,
    width: '90px',
  },
  {
    title: '回调状态',
    dataIndex: 'notifyStatus',
    slot: true,
    width: '90px',
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
  },
  {
    title: '签名处理方式',
    dataIndex: 'upDefault1',
    slot: true,
    width: '120px',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '签名时间',
    dataIndex: 'signTime',
  },
]
// 客户签名表头
const customerSignatureHeaderColumns = [
  {
    title: '唯一标识名',
    dataIndex: 'uniqueid',
    width: '120px',
  },
  {
    title: '签名请求ID',
    dataIndex: 'requestid',
  },
  {
    title: '签名客户',
    dataIndex: 'firmName',
  },
  {
    title: '签名时间',
    dataIndex: 'signTime',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '签名状态',
    dataIndex: 'status',
    slot: true,
  },
]
export default {
  name: 'trustedUser',
  components: {
    MyForm,
    MyTable,
  },
  data() {
    return {
      idCodeType,
      doctorDetailStatusType,
      doctorSignatureHeaderColumns,
      customerSignatureHeaderColumns,
      doctorSignStatusTypeEnum,
      FirmStatusTypeEnum,
      processTypeObj,
      headerColumns: doctorSignatureHeaderColumns,
      firmList: [],
      formData: {
        form: {
          serviceType: '0',
          clientId: '',
          signStatus: '',
          uniqueId: '',
          userName: '',
          firmStatus: '',
          dateValue: [moment().format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
          patientName: '',
        },
        options: [
          {
            title: '创建时间',
            key: 'dateValue',
            // type: 'date-to-date',
            type: 'datetime-to-datetime',
            className: 'width400',
          },
          {
            title: '服务类型',
            key: 'serviceType',
            type: 'select',
            option: {
              data: serviceStatusTypeOptions,
            },
            onchange: (val) => {
              this.page.pageNum = 1
              this.serviceType = val
              this.formData.form.signStatus = ''
              if (val === '2') {
                // 客户签名
                this.headerColumns = customerSignatureHeaderColumns
                this.getFirmSignData()
                const back = this.formData.options.filter((item) => {
                  return item.key === 'userName'
                })
                console.log(back)
                if (back.length > 0) {
                  this.formData.options.splice(
                    this.formData.options.length - 1,
                    1
                  )
                }
              } else {
                this.headerColumns = doctorSignatureHeaderColumns
                this.getTableList()
                const back = this.formData.options.filter((item) => {
                  return item.key === 'userName'
                })
                if (back.length === 0) {
                  this.formData.options.push({
                    title: '关键字搜索',
                    key: 'userName',
                    type: 'text',
                    placeholder: '输入医师姓名/患者姓名搜索',
                    className: 'width250',
                  })
                }
              }
            },
          },
          {
            title: '唯一标识',
            key: 'uniqueId',
            type: 'text',
            option: {
              data: [],
            },
            clearable: true,
          },
          {
            title: '客户名称',
            key: 'clientId',
            type: 'select',
            option: {
              data: this.firmList,
            },
            filterable: true,
            clearable: true,
            className: 'width300',
          },
          {
            title: '签名状态',
            key: 'signStatus',
            type: 'select',
            option: {
              data: signStatusTypeOptions,
            },
            clearable: true,
            // onchange: (val) => {
            //  console.log(val)
            // },
          },
          {
            title: '关键字搜索',
            key: 'userName',
            type: 'text',
            placeholder: '输入医师姓名/患者姓名搜索',
            className: 'width250',
          },
        ],
      },
      dateValue: '',
      tableData: [],
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      serviceType: '',
      detailDialogVisible: false,
      detailInfo: {},
      grantUniqueId: '',
      customerDetailDialogVisible: false,
      customerDetailInfo: {},
      exportCheckSearch: false, // 导出之前先判断是否搜素
    }
  },
  watch: {
    'formData.form.serviceType': {
      handler(newName, oldName) {
        console.log(newName, oldName)
        this.formData.options[4].option.data =
          newName === '2' ? FirmStatusTypeOptions : signStatusTypeOptions
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getClientIdList()
  },
  mounted() {
    bus.$on('tabChange', ()=>{
      console.log('点击了')
      this.exportCheckSearch = false;
    })
  },
  methods: {
    addBase64,
    getClientIdList() {
      getFirmListByAgent().then((res) => {
        this.firmList = formatArrOptions(res, 'firmName', 'clientId')
        this.firmList.unshift({ value: '', label: '全部' })
        this.formData.options[3].option.data = this.firmList
        // console.log('this.firmList', this.firmList)
      })
    },
     // 导出
     exportData() {
      if(!this.exportCheckSearch){
        this.$message.warning('请先搜索，在进行导出!')
        return
      }
      if(this.page.total > 10000){
        this.$message.warning('最大支持导出 1w 条数据，请缩小范围后重试!')
        return
      }

      const { clientId, uniqueId, dateValue, signStatus } = this.formData.form
      if (!clientId) {
        this.$message.warning('请选择先一个客户!')
        return
      }
      let params = {}
      let typeName = ''
      let urlName = ''
      
      if(this.serviceType === '2'){
        typeName =  '客户签名'
        urlName = 'exportFirmSign'

        params = {
          searchBean: {
            status: signStatus,
            createStartDate: dateValue
              ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss')
              : '',
            createEndDate: dateValue
              ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
              : '',
            uniqueId: uniqueId,
            firmId: clientId,
          }
        }
      } else {
        typeName =  '医生签名'
        urlName = 'exportDoctorSignOrder'

        params = {
          searchParam: {
            statusList: signStatus!==''?[signStatus]:[],
            startDate: dateValue
              ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss')
              : '',
            endDate: dateValue
              ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
              : '',
            uniqueId: uniqueId,
            clientId: clientId,
          },
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        }
      }

      this.$API[urlName](params).then((response) => {
        const blob = response
        const a = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // 设置文件名称
        a.download = `${typeName}订单列表${moment().format(
          'YYYY-MM-DD'
        )}.xls`
        a.click()
      })
    },
    // 搜索
    searchForm() {
      const { serviceType } = this.formData.form
      this.page.pageNum = 1
      this.serviceType = serviceType;
      serviceType === '2' ? this.getFirmSignData() : this.getTableList()
    },
    getTableList() {
      const { clientId } = this.formData.form
      if (!clientId) {
        this.$message.error('请选择一个查询客户!')
        return
      }
      const { userName, uniqueId, signStatus, dateValue } = this.formData.form

      const params = {
        searchParam: {
          userName: userName,
          statusList: signStatus ? [signStatus] : [],
          startDate: dateValue ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss') : '',
          endDate: dateValue
            ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
            : '',
          uniqueId: uniqueId,
          clientId: clientId,
          patientName: userName,
        },
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      // console.log('params',params)
      this.$API
        .doctorSignListByAgent(params)
        .then((res) => {
          const data=res.data.list
          data.forEach((itemList)=>{
            let newitemList=itemList
            const backList= this.firmList.filter((item)=>item.value===newitemList.firmId)
            newitemList.clientIdName=backList[0].label
          })
          this.exportCheckSearch = true;
          this.tableData =data
          this.page.total = res.data.total
        })
        .catch()
    },
    signStatusTag(status) {
      let color = ''
      switch (Number(status)) {
        case doctorSignStatusTypeEnum.Signed: //已签
        case 4:
          color = tagColor.green
          break
        case doctorSignStatusTypeEnum.Abolished: //已经作废
        case 43:
          color = tagColor.steel
          break
        case doctorSignStatusTypeEnum.New:
          color = tagColor.purple
          break
        case doctorSignStatusTypeEnum.OverwritePending:
          color = tagColor.processingColor
          break
        case doctorSignStatusTypeEnum.Unaccalimed:
          color = tagColor.errorColor
          break
        case doctorSignStatusTypeEnum.Deleted:
          color = tagColor.salmon
          break
        case doctorSignStatusTypeEnum.VisaDenied:
        case 41:
          color = tagColor.orange
          break
        case doctorSignStatusTypeEnum.Expired: //已经过期
        case 42:
          color = 'mocha'
          break
        case FirmStatusTypeEnum.SignedAndCallback:
          color = tagColor.solidGreen
          break
        default:
          color = tagColor.processingColor
          break
      }
      return color
    },
    getNotifyStatusName(row) {
      if ([2, 6, 7, 9].includes(row.status)) {
        if (row.notifyStatus) {
          return '已回调'
        }
        return '未回调'
      }
      return '--'
    },
    // 查看详情
    customerDetail(record) {
      console.log(record)
      const { firmId, createTime, userUniqueid, uniqueid } = record
      if (this.formData.form.serviceType === '2') {
        // 客户签名详情
        this.customerDetailDialogVisible = true
        const params = {
          signId: uniqueid,
        }
        this.$API.firmSignDetailByAgent(params).then((result) => {
          this.customerDetailInfo = result.data
        })
      } else {
        this.grantUniqueId = record.grantUniqueId ? record.grantUniqueId : ''
        this.detailDialogVisible = true
        const params = {
          clientId: firmId,
          createTime: createTime,
          signId: uniqueid,
          userId: userUniqueid,
        }
        this.$API.doctorSignDetailByAgent(params).then((result) => {
          this.detailInfo = result.data
        })
      }
    },
    // 医师签名--补偿通知
    msgRepeatSend(record) {
      const { uniqueid, createTime, userUniqueid, firmId } = record
      const params = {
        signId: uniqueid,
        clientId: firmId || '',
        userId: userUniqueid,
        createTime: createTime,
      }
      this.$API
        .msgRepeatSendByAgent(params)
        .then(() => {
          this.$message.success('补偿通知发送成功!')
        })
        .catch()
      //分别对医师签名、客户签名进行补偿通知
    },
    /********************************客户签名***********************************/
    // 客户签名table列表
    getFirmSignData() {
      const { clientId } = this.formData.form
      if (!clientId) {
        this.$message.error('请选择一个查询客户!')
        return
      }
      const { uniqueId, dateValue, signStatus } = this.formData.form
      console.log(dateValue)
      const params = {
        searchBean: {
          status: signStatus,
          createStartDate: dateValue
            ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss')
            : '',
          createEndDate: dateValue
            ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
            : '',
          uniqueId: uniqueId,
          firmId: clientId,
        },
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      this.$API
        .firmSignListByAgent(params)
        .then((res) => {
          this.exportCheckSearch = true;
          this.tableData = res.data.list
          this.page.total = res.data.total
        })
        .catch()
    },
    pageNumChange(pageNum) {
      this.page.pageNum = pageNum
      const { serviceType } = this.formData.form
      serviceType === '2' ? this.getFirmSignData() : this.getTableList()
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize
      const { serviceType } = this.formData.form
      serviceType === '2' ? this.getFirmSignData() : this.getTableList()
    },
  },
}
</script>
  
  <style lang="less" scoped>
.detailInfo-container {
  h3 {
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
  }
  .el-col {
    margin-bottom: 10px;
  }
  .marginBottom20 {
    margin-bottom: 20px;
  }
  .marginright20 {
    margin-right: 20px;
  }
}
</style>